import queryString from 'query-string';
import {useMemo} from 'react';
import {useLocation} from 'react-router';
import {Wish} from '~/library/prelude';
import {getCookie} from '~/shared/utils/tools';

export function useUTM() {
    const location = useLocation();
    return useMemo(() => {
        const query = queryString.parse(location.search);
        try {
            const parsed = Wish.assert(UtmQuery, query);
            const utm_source = parsed.utm_source || String(getCookie('source') || '') || undefined;
            const utm_medium = parsed.utm_medium || String(getCookie('medium') || '') || undefined;
            const utm_campaign = parsed.utm_campaign || String(getCookie('campaign') || '') || undefined;
            const invite_code = parsed.invite || String(getCookie('code') || '') || undefined;
            const referer = (() => {
                if (parsed.referer) {
                    return decodeURIComponent(String(parsed.referer));
                }
                if (getCookie('url')) {
                    return decodeURIComponent(String(getCookie('url')));
                }
                return undefined;
            })();

            return {
                utm_source,
                utm_medium,
                utm_campaign,
                invite_code,
                referer,
            };
        } catch (_) {
            return {};
        }
    }, []);
}

export type UtmQuery = typeof UtmQuery.Type;
export const UtmQuery = Wish.struct({
    utm_source: Wish.string.pipe(Wish.optional),
    utm_medium: Wish.string.pipe(Wish.optional),
    utm_campaign: Wish.string.pipe(Wish.optional),
    referer: Wish.string.pipe(Wish.optional),
    invite: Wish.string.pipe(Wish.optional),
});
